import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SessionService } from '../session.service';

const PUBLIC_PREFIXES = ['/clientes', '/aut', '/home', '/404-not-found'];

export const StaffAuthGuard: CanActivateChildFn = (route, state) => {
    const router = inject(Router);
    const session = inject(SessionService);
    const toastr = inject(ToastrService);
    if (PUBLIC_PREFIXES.some(p => state.url === p || state.url.startsWith(p + '/') || state.url.startsWith(p + '?'))) {
        return true;
    }
    return session.initialize().then(() => {
        const current = session.snapshot;
        if (current.status === 'authenticated') return true;
        if (current.status === 'anonymous') return router.parseUrl('/home');
        toastr.error('No se pudo verificar la sesión. Reintenta recargando cuando el servidor esté disponible.');
        return false;
    });
};
